import { PaymentItemType } from './enums/payment-item-type';
import { PaymentItem } from './payment-item';
import { PaymentItemDiscountBalanceRange } from './payment-item-discount-balance-range';

export class AccountPaymentItem extends PaymentItem {
	minPaymentDue: number;
	accountDescription: string;
	latestStatementDocumentKey: number | null;
	discountBalanceRanges: Array<PaymentItemDiscountBalanceRange> = [];
	discount: number | null;
	adjustedBalances: AdjustedBalances;

	constructor() {
		super();
		this.itemType = PaymentItemType.Account;
	}

	getDiscount() {
		this.discount = null;
		this.discountBalanceRanges.forEach((range) => {
			if (this.initialAmount >= range.min && range.max >= this.initialAmount) {
				this.discount = range.payInFullDiscount;
			}
		});
	}
}

class AdjustedBalances {
	totalBalance: number | null;
	pendingBalance: number | null;
}
